import OrganizationChart from "./ChartContainer";

import "./ChartNode.css";

function Caac(props) {



  return (
    <OrganizationChart chartClass="myChart" datasource={props.ds} />
  );
}

export default Caac;